<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: '0.00'
  },
  placeholder: {
    type: String,
    default: '0.00'
  },
  class: {
    type: String,
    default: 'form-control'
  }
})

const emit = defineEmits(['update:modelValue'])
const localValue = ref(parseFloat(props.modelValue || '0.00').toString())

// Keep local in sync if parent changes
watch(
    () => props.modelValue,
    (val) => {
      if (val === undefined || val === null || val === '' ) {
        localValue.value = '0.00'
      } else if (val !== undefined && val !== null && val.toString() !== localValue.value) {
        localValue.value = val.toString()
      }
    }
)

// Update parent as user types
function onInput(e) {
  localValue.value = e.target.value
}

// Format on blur
function onBlur() {
  const num = parseFloat(localValue.value)
  if (isNaN(num)) {
    localValue.value = ''
    emit('update:modelValue', null)
    return
  }
  const fixed = num.toFixed(2)
  localValue.value = fixed
  emit('update:modelValue', parseFloat(fixed))
}

// Select all text on focus
function onFocus(e) {
  e.target.select()
}
</script>

<template>
  <input
      type="text"
      v-model="localValue"
      :placeholder="props.placeholder"
      :class="props.class"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
  />
</template>
